module.exports = __webpack_public_path__ + "img/yf_pic.1043615b.png";